var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { ReactElementFactory, Scroll, SurveyActionBar, SurveyElementBase, SurveyHeader } from "survey-react-ui";
import { SurveyPageNavigator } from "../PageNavigator";
import { SurfacePlaceholder } from "../components/SurfacePlaceholder";
var TabDesignerComponent = /** @class */ (function (_super) {
    __extends(TabDesignerComponent, _super);
    function TabDesignerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.denyUpdate = function () {
            _this.denyComponentUpdate();
        };
        _this.allowUpdate = function () {
            _this.allowComponentUpdate();
        };
        _this.addDragDropEvents = function () {
            _this.creator.onDragStart.add(_this.denyUpdate);
            _this.creator.onDragClear.add(_this.allowUpdate);
        };
        _this.clearDragDropEvents = function () {
            _this.creator.onDragStart.remove(_this.denyUpdate);
            _this.creator.onDragClear.remove(_this.allowUpdate);
        };
        return _this;
    }
    Object.defineProperty(TabDesignerComponent.prototype, "model", {
        get: function () {
            return this.props.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabDesignerComponent.prototype, "creator", {
        get: function () {
            return this.model.creator;
        },
        enumerable: false,
        configurable: true
    });
    TabDesignerComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.addDragDropEvents();
    };
    TabDesignerComponent.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.clearDragDropEvents();
        _super.prototype.componentWillUnmount.call(this);
    };
    TabDesignerComponent.prototype.getStateElements = function () {
        return [this.model, this.model.survey, this.model.pagesController];
    };
    TabDesignerComponent.prototype.getRenderedPages = function () {
        var _this = this;
        var renderedPages = [];
        if (this.creator.pageEditMode !== "bypage") {
            var pages = this.model.pages;
            pages.forEach(function (page) {
                renderedPages.push(_this.createRenderedPage(page, "svc-page", page == _this.model.newPage));
            });
        }
        else {
            var page2Display = this.model.pagesController.page2Display;
            if (!!page2Display) {
                renderedPages.push(this.createRenderedPage(page2Display, "svc-page", this.model.newPage === page2Display));
            }
        }
        return renderedPages;
    };
    TabDesignerComponent.prototype.createRenderedPage = function (page, className, isGhostPage) {
        return React.createElement(PageWrapperComponent, { key: page === null || page === void 0 ? void 0 : page.id, page: page, isGhost: isGhostPage, creator: this.creator, className: className });
    };
    TabDesignerComponent.prototype.renderElement = function () {
        var _this = this;
        var designerTabClassName = "svc-tab-designer " + this.model.getRootCss();
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "svc-flex-column" }, this.model.isToolboxVisible ? ReactElementFactory.Instance.createElement("svc-toolbox", { model: this.creator }) : null),
            React.createElement("div", { className: designerTabClassName, onClick: function () { return _this.model.clickDesigner(); } },
                React.createElement(Scroll, null,
                    React.createElement("div", { className: "svc-tab-designer_content" }, this.model.showPlaceholder ? this.renderPlaceHolder() : this.renderTabContent())))));
    };
    TabDesignerComponent.prototype.renderHeader = function (condition) {
        if (!condition)
            return null;
        var survey = this.creator.survey;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "svc-designer-header" },
                React.createElement(SurveyHeader, { survey: survey }))));
    };
    TabDesignerComponent.prototype.renderPlaceHolder = function () {
        var surveyHeader = this.renderHeader(this.creator.showSurveyHeader && this.creator.showHeaderInEmptySurvey);
        return (React.createElement(React.Fragment, null,
            surveyHeader,
            React.createElement("div", { className: "svc-designer__placeholder-container", "data-sv-drop-target-survey-element": "newGhostPage" },
                this.renderPlaceHolderContent(),
                this.createRenderedPage(this.model.newPage, "svc-designer-placeholder-page", true))));
    };
    TabDesignerComponent.prototype.renderPlaceHolderContent = function () {
        return React.createElement(SurfacePlaceholder, { name: "designer", placeholderTitleText: this.model.placeholderTitleText, placeholderDescriptionText: this.model.placeholderDescriptionText });
    };
    TabDesignerComponent.prototype.renderTabContent = function () {
        var survey = this.creator.survey;
        var surveyHeader = this.renderHeader(this.creator.showSurveyHeader);
        var style = __assign({}, this.model.surfaceCssVariables);
        style.maxWidth = survey.renderedWidth;
        var tabTools = this.renderTabTools();
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: this.model.designerCss, style: style },
                surveyHeader,
                this.getRenderedPages()),
            tabTools));
    };
    TabDesignerComponent.prototype.renderTabTools = function () {
        if (!this.model.showSurfaceTools)
            return null;
        var pageNavigator = this.creator.showPageNavigator ?
            React.createElement("div", { className: "svc-tab-designer__page-navigator" },
                React.createElement(SurveyPageNavigator, { pagesController: this.model.pagesController, pageEditMode: this.model.creator.pageEditMode }))
            : null;
        var surfaceToolbar = this.model.showSurfaceToolbar ?
            React.createElement(SurveyActionBar, { model: this.model.surfaceToolbar, handleClick: false })
            : null;
        return React.createElement("div", { className: "svc-tab-designer__tools" },
            pageNavigator,
            surfaceToolbar);
    };
    return TabDesignerComponent;
}(SurveyElementBase));
export { TabDesignerComponent };
ReactElementFactory.Instance.registerElement("svc-tab-designer", function (props) {
    return React.createElement(TabDesignerComponent, props);
});
var PageWrapperComponent = /** @class */ (function (_super) {
    __extends(PageWrapperComponent, _super);
    function PageWrapperComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.id = "PageWrapperCallback_".concat(++PageWrapperComponent.ID);
        _this.state = { changed: 0 };
        return _this;
    }
    PageWrapperComponent.prototype.render = function () {
        var _a, _b;
        var pageContent = !!this.props.page ? ReactElementFactory.Instance.createElement("svc-page", { survey: this.props.creator.survey, page: this.props.page, creator: this.props.creator, isGhost: this.props.isGhost }) : null;
        return React.createElement("div", { className: this.props.className, "data-sv-drop-target-page": (_a = this.props.page) === null || _a === void 0 ? void 0 : _a.name, "data-sv-drop-target-survey-element": this.props.isGhost ? "newGhostPage" : (_b = this.props.page) === null || _b === void 0 ? void 0 : _b.name }, pageContent);
    };
    PageWrapperComponent.prototype.setupCallback = function (page) {
        var _this = this;
        if (!page)
            return;
        page.registerFunctionOnPropertyValueChanged("name", function () {
            _this.setState({ changed: !!_this.state && _this.state.changed ? _this.state.changed + 1 : 1 });
        }, this.id);
    };
    PageWrapperComponent.prototype.clearCallback = function (page) {
        if (!page)
            return;
        page.unRegisterFunctionOnPropertyValueChanged("name");
    };
    PageWrapperComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.page !== this.props.page) {
            this.clearCallback(prevProps.page);
            this.setupCallback(this.props.page);
        }
    };
    PageWrapperComponent.prototype.componentDidMount = function () {
        this.setupCallback(this.props.page);
    };
    PageWrapperComponent.prototype.componentWillUnmount = function () {
        this.clearCallback(this.props.page);
    };
    PageWrapperComponent.ID = 0;
    return PageWrapperComponent;
}(React.Component));
